import { render } from "./PatientAdministrationSummaryModal.vue?vue&type=template&id=1d6130b8"
import script from "./PatientAdministrationSummaryModal.vue?vue&type=script&lang=js"
export * from "./PatientAdministrationSummaryModal.vue?vue&type=script&lang=js"

import "./PatientAdministrationSummaryModal.vue?vue&type=style&index=0&id=1d6130b8&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__